<template>
  <div class="wrap">
    <div class="tech">
      <img :src="banner" alt="">
    </div>
    <div class="demo">
      <ul class="list">
        <li v-for="item in dataList" @click="skip(item)">
          <div class="left">
            <img :src="item.middlePicture">
          </div>
          <div class="right">
            <h3 class="title != null">{{item.title}}</h3>
            <p class="name" v-if="item.teacher != null">{{ item.teacher }}</p>
            <p class="name" v-if="item.teacherArr != null">大　咖：{{ item.teacherArr.truename }} {{ item.teacherArr.title }}</p>
            <p class="liveTime" v-if="item.type != 'normal'">{{ item.liveTime }}</p>
            <p :class="item.money=='0.00' ? 'liveprice_green' : 'liveprice_red'" v-show="item.money&&item.money!=''">{{ item.money=='0.00'? '免费': '￥ '+item.money }}</p>  
          </div>
        </li>
      </ul>
    </div>
    <returnPre></returnPre>
  </div>
</template>

<script>
  import api from 'api'
  export default {
    name: "subjectdetail",
    data () {
      return {
        banner:'',
        accountType: 1, // 1 主办方 2 嘉宾
        techurl:'',
        dataList: [],
        axiosUrl: '', // 发送请求的地址
        uid: '',
        aid: '',
        orgName: '' // 主办方名称
      }
    },
    created () {
    },
    mounted() {
      this.initData()
    },
    methods: {
      // 初始化
      async initData() {
        var id = this.$route.query.id
        this.subjectInfo(id)
        const params = {
          targetType: 'subject',
          targetId: this.$route.query.id
        }
        const res = await api.common.getShareData(params);
        this.getShareInfo(true, res.data.shareTitle, res.data.shareDesc, res.data.shareImg)
      },
      // 获取专题信息
      async subjectInfo(id) {
        var params = {
          id: id
        };
        var res = await api.topic.subjectInfo(params);
        this.banner = res.banner.indexOf('https://') == -1 ? 'https://www.itdks.com/' + res.banner : res.banner;
        this.dataList = res.list;
        this.dataList.forEach(item =>{
          item.middlePicture = item.poster
        })
      },
      // 跳转
      skip(item) {
        var type = '';
        if (item.type == 1) {
          type='bjy';
          window.location.href='https://www.itdks.com/Home/mobile/detail?id=' + item.id +'&type=' + type
        }
        if (item.type == 2) {
          type = 'normal';
          window.location.href='https://www.itdks.com/Home/mobile/detail?id=' + item.id +'&type=' + type
        }
        if (item.type == 3) {
          type='live';
          window.location.href='https://www.itdks.com/Home/Act/apply?id=' + item.id +'&mUId=' + this.$route.query.uid
        }
      },
    }
  }
</script>

<style scoped lang="less">
.wrap{
  position: relative;
  overflow-y: hidden;
  .tech{

    width: 100%;
    /* height: 400px; */
    display: flex;
    justify-content: center;

    img{
      position: relative;
      margin: 0;
      width: 100%;
      height: inherit;
      text-align: center;

    }
  }
  .techscroll{

    }}
    * {
      margin: 0;
      padding: 0;
      outline: none;
    }
    h3{
      margin-top: -8px;
    }
    .demo {
      margin-bottom: 92px;
    }

    .demo .list li {
      /* width: 750px; */
      height: 219px;
      padding: 25px 28px;
      box-sizing: border-box;
      border-bottom: 1px solid #dedede; /*no*/
      list-style: none;
      .left {
        width: 270px;
        height: 169px;
        line-height: 169px;
        margin-right: 10px;
        float: left;
        border-radius: 10px;
        overflow: hidden;
        position: relative;
        display: flex;
        > img {
          width: 270px;
          height: 169px;
        }
        .Play {
          position: absolute;
          width: 50px;
          height: 50px;
          right: 5px;
          bottom: 55px;
          z-index: 10;
          img {
            width: 50px;
            height: 50px;
          }
        }
        p {
          position: absolute;
          line-height: 30px;
          left: -10px;
          color: #fff;
          top: -2px;
          font-size: 18px; /*px*/
          padding: 2px 10px;
        }
        .living {
        }
        .begin {

        }
        .agin {
        }
        .end {
        }
      }
      .right {
        width: 390px;
        margin-left: 20px;
        float: right;
        font-size: 24px; /*px*/
        .title {
          font-size: 28px; /*px*/
          /* line-height: 56px; */
          font-weight: 500;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .name {
          color: #f2845a;
          /* margin-top: 30px; */
          margin-bottom: 6px;
          height: 32px;
          overflow: hidden;
          background: url(../../assets/img/title_ico.png) no-repeat left center;
          padding-left: 28px;
          background-size: 26px 26px;
        }
        .organizer {
          color: #f3855d;
          height: 36px;
          margin-top: 32px;
          text-overflow:ellipsis;
          white-space: nowrap;
          overflow: hidden;
          background: url(../../assets/img/title_ico.png) no-repeat left center;
          padding-left: 28px;
          background-size: 26px 26px;
        }
        .liveTime,
        .hitNum {
          font-size: 24px !important;
          color: #8c8c8c;
          span {
            float: right;
          }
        }
        .liveTime,.livetime{
          background: url(./../../assets/img/time_ico.png) no-repeat left center;
          padding-left: 28px;
          background-size: 26px 26px;
        }
        .hitNum {
          margin-top: 14px;
          span {
            color: #fe0200;
            font-weight: 700;
          }
        }
        .livetime {
          color: #8c8c8c;
          span {
            float: right;
          }
        }
        .liveprice_red{
          font-size: 24px !important;
          color: #f3855d;
          margin-top: 5px;
        }
        .liveprice_green{
          font-size: 24px !important;
          color:#559DD7;
          margin-top: 5px;
        }
        .pptNum{
          position: absolute;
          width: 30px;
          height: 30px;
          right: 20px;
          background: url(./../../assets/img/ppt_ico.png) no-repeat left top;
          padding-left: 30px;
          background-size: 26px 26px;
          margin-top: 10px;
        }
      }
    }
  </style>



// WEBPACK FOOTER //
// src/components/HomePage-Children/subjectDetail.vue